export interface Currency {
  id: string;
  slug: string;
  coingeckoId: string;
  coingeckoNetwork: string;
  coingeckoTokenAddress: string;
  isActive: boolean;
}

export enum EventTemplateType {
  CurrencyPricePrediction = 'currency_price_prediction',
}

const EVENT_TEMPLATE_TYPE_LABELS: Record<EventTemplateType, string> = {
  [EventTemplateType.CurrencyPricePrediction]: 'Currency price prediction',
};

export const formatEventTemplateType = (type: EventTemplateType): string =>
  EVENT_TEMPLATE_TYPE_LABELS[type] ?? type;

export interface CurrencyEventSchedule {
  id: string;
  currencyId: string;
  currencySlug: string;
  templateId: string;
  templateType: EventTemplateType;
  cron: string;
  nextRunAt: Date;
}

export interface EventTemplate {
  id: string;
  type: EventTemplateType;
  name: string;
}
